
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 12.23c0-.68-.056-1.363-.176-2.032H12.2v3.85h5.51a4.624 4.624 0 01-2.039 3.04v2.498h3.288C20.89 17.844 22 15.272 22 12.23z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M12.2 22c2.752 0 5.073-.885 6.763-2.414l-3.287-2.499c-.915.61-2.096.956-3.472.956-2.661 0-4.918-1.76-5.728-4.127H3.083v2.576C4.815 19.87 8.343 22 12.2 22z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M6.472 13.916a5.877 5.877 0 010-3.829V7.512H3.083a9.831 9.831 0 000 8.98l3.39-2.576z","fill":"#FBBC04"}}),_c('path',{attrs:{"d":"M12.2 5.957a5.606 5.606 0 013.914 1.5l2.913-2.855A9.916 9.916 0 0012.2 2C8.343 2 4.816 4.131 3.083 7.512l3.39 2.576c.805-2.37 3.066-4.13 5.728-4.13z","fill":"#EA4335"}})])
          )
        }
      }
    